import { useContext, useEffect, useState, } from "react";

import { TransactionMonitoringSystemConfigUrl } from "../../../platform/constants/backend-constants";
import ListPage from "../../../shared/components/list-page/list-page";
import { IColumn } from "../../../shared/components/normal-table/normal-table";
import Spinner from "../../../shared/components/spinner/spinner";
import { roleWrite, roleAdmin } from "../../../shared/constants/user-roles";
import AuthContext from "../../../shared/context/auth-context";
import useHttp from "../../../shared/hooks/use-http";
import { getAllData, deleteMultiple } from "../../../shared/utils/api";
import { outputTypeOptions, scoreLocationOptions, aggregateStoreTypeOptions } from "../../../shared/utils/static-values";
import { validateLoadingStatusNew } from "../../../shared/utils/utils";
import "./transaction-monitoring-system-config.scss";

const columns: IColumn[] = [
  {
    key: "name",
    displayName: "Name",
    dataType: {
      type: "text",
    }
  },
  {
    key: "output_type",
    displayName: "Output type",
    dataType: {
      type: "enumeration",
      values: outputTypeOptions
    }
  },
  {
    key: "score_location",
    displayName: "Score location",
    dataType: {
      type: "enumeration",
      values: scoreLocationOptions
    }
  },
  {
    key: "score_location_table_name",
    displayName: "Score location table name",
    dataType: {
      type: "text",
    }
  },
  {
    key: "source_table_name",
    displayName: "Source table name",
    dataType: {
      type: "text",
    }
  },
  {
    key: "aggregate_store_type",
    displayName: "Aggregate store type",
    dataType: {
      type: "enumeration",
      values: aggregateStoreTypeOptions
    }
  },
  {
    key: "database_connection_name",
    displayName: "Database connection",
    dataType: {
      type: "reference",
      values: []
    },
    nonSortable: true
  }
];

const TransactionMonitoringSystemConfig = () => {
  const [data, setData] = useState(undefined);
  const [unblockInput, setUnblockInput] = useState(false);
  const [sortedBy, setSortedBy] = useState("?order_by=name asc");
  const authCtx = useContext(AuthContext);
  const { sendRequest: getSortBy, status: getSortByStatus, data: getSortByData, error: errorGetSortByData } = useHttp(getAllData, true, authCtx.token, undefined, "analytics");
  const { sendRequest: deleteMultipleRequest, status: allStatusDelete, data: loadedDataDelete, error: errorDelete } = useHttp(deleteMultiple, false, authCtx.token, undefined, "analytics");

  useEffect(() => {
    const rolesArray = authCtx.selectedTenant.roles;
    if (rolesArray.indexOf(roleWrite) !== -1 || rolesArray.indexOf(roleAdmin) !== -1) {
      setUnblockInput(true);
    }
  }, [authCtx.selectedTenant, authCtx.systemAdmin]);

  useEffect(() => {
    getSortBy("tmsconfigs", "?order_by=name asc");
  }, [getSortBy]);

  useEffect(() => {
    if (getSortByStatus === "completed" && !errorGetSortByData) {
      setData(getSortByData);
    }
  }, [getSortByStatus]);

  useEffect(() => {
    if (allStatusDelete === "completed" && !errorDelete) {
      setData(loadedDataDelete);
      authCtx.setOnboardingAnalyticsToggleHandler();
    }
  }, [allStatusDelete]);

  const handleOnDelete = (ids: string[]) => {
    deleteMultipleRequest(`tmsconfigs${sortedBy}`, { ids });
  };

  const sortBy = (sortingQuery: string) => {
    getSortBy("tmsconfigs", `${sortingQuery}`);
    setSortedBy(sortingQuery);
  };

  return (
    <div className="transactionMonitoringSystemConfig">
      {validateLoadingStatusNew([getSortByStatus, allStatusDelete]) && <Spinner />}
      <ListPage
        title={"Transaction monitoring system configs"}
        columns={columns}
        sortBy={sortBy}
        defaultSortCol={"name"}
        unblockInput={unblockInput}
        dataUrl={TransactionMonitoringSystemConfigUrl}
        pageMode={"nonEditable"}
        handleOnDelete={handleOnDelete}
        fetchedData={data}
        allStatus={getSortByStatus}
        allStatusDelete={allStatusDelete}
        tooltipTxt={"TMSC is needed to establish a proper connection to a remote DB"}
      />
    </div>
  );
};

export default TransactionMonitoringSystemConfig;